
import Vue from "vue";
import Component from "vue-class-component";
import { Getter, State } from "vuex-class";
import { Prop } from "vue-property-decorator";

@Component
export default class HeaderRegister2 extends Vue {
  @State("school", { namespace: "school" })
  private school!: any;
  @State("template", { namespace: "school" })
  private template!: any;

  @Prop({ default: false })
  private isHighSchool!: boolean;
  @Prop({ default: false })
  private canReSendOtp!: boolean;
  @Prop({ default: null })
  private candidateId!: any;
  @Prop({ default: false })
  private isTracer!: boolean;
  @Prop({ default: null })
  private onDegreeChange!: any;
  @Prop({ default: null })
  private onlyNumber!: any;
  @Prop({ default: false })
  private isEmail!: boolean;
  @Prop({ default: null })
  private sendOtp!: any;
  @Prop({ default: null })
  private next!: any;
  @Prop({ default: null })
  private user!: any;
  @Prop({ default: [] })
  private degrees!: Array<any>;
  @Prop({ default: [] })
  private majors!: Array<any>;
  @Prop({ default: 1 })
  private step!: number;
  @Prop({ default: "" })
  private otpTimer!: string;
  @Prop({ default: false })
  private isReSendOtp!: boolean;
  @Prop({ default: "" })
  private otp!: string;
  @Prop({ default: [] })
  private genders!: Array<any>;
  @Prop({ default: [] })
  private icons!: Array<any>;

  @Getter("twoColor")
  private twoColor!: { text: string; bg: string; border: string };

  private get twoBgColor() {
    return this.twoColor.bg;
  }
}
